<template>
	<div id="main">
	        <div class="bg-shapes">
	            <div class="shape"></div>
	            <div class="shape"></div>
	            <div class="shape"></div>
	        </div>
	        
	        <div class="wrapper">
	            <div class="login-content">
	                <div class="login-intro">
	                    <h1>{{ systemInfo.title }}</h1>
	                    <p></p>
	                    
	                    <div class="features">
	                        <div class="feature">
	                            <div class="feature-icon">
	                                <i class="el-icon-s-order"></i>
	                            </div>
	                            <div>多维度考核管理</div>
	                        </div>
	                        <div class="feature">
	                            <div class="feature-icon">
	                                <i class="el-icon-timer"></i>
	                            </div>
	                            <div>实时进度跟踪</div>
	                        </div>
	                        <div class="feature">
	                            <div class="feature-icon">
	                                <i class="el-icon-data-analysis"></i>
	                            </div>
	                            <div>丰富统计图表</div>
	                        </div>
	                        <div class="feature">
	                            <div class="feature-icon">
	                                <i class="el-icon-chat-line-square"></i>
	                            </div>
	                            <div>360度全方位评估</div>
	                        </div>
	                    </div>
	                </div>
	                
	                <div class="login-box">
	                    
	                    <h3 class="title">欢迎登录绩效考核系统</h3> 
	                    
	                    <el-form :model="loginForm" status-icon :rules="rules" ref="ruleForm" label-width="80px">
	                        <el-form-item label="账号" prop="username">
	                            <el-input 
	                                type="text" 
	                                v-model="loginForm.username" 
	                                autocomplete="off"
	                                placeholder="请输入账号"
	                                prefix-icon="el-icon-user">
	                            </el-input>
	                        </el-form-item>
	                        
	                        <el-form-item label="密码" prop="password">
	                            <el-input 
	                                type="password" 
	                                v-model="loginForm.password" 
	                                autocomplete="off" 
	                                show-password
	                                placeholder="请输入密码"
	                                prefix-icon="el-icon-lock">
	                            </el-input>
	                        </el-form-item>
	                        <el-form-item label="验证码" prop="captcha">
	                            <div class="captcha-container">
	                                <el-input 
	                                    v-model="loginForm.captcha" 
	                                    auto-complete="off" 
	                                    placeholder="请输入验证码"
	                                    prefix-icon="el-icon-key">
	                                </el-input>
	                                <img :src="codeUrl" @click="getCode" class="login-code-img" />
	                            </div>
	                        </el-form-item>
	                        
	                        <el-form-item>
	                            <div class="button-container">
	                                <el-button type="primary" @click="submitForm('ruleForm')">登录系统</el-button>
	                                <el-button @click="resetForm('ruleForm')">重置</el-button>
	                            </div>
	                        </el-form-item>
	                    </el-form>
	                    
	                    <!-- 微信授权登录 
	                    <div class="wechat-login-section">
	                        <div class="divider">
	                            <span>或使用微信账号登录</span>
	                        </div>
	                        <div class="wechat-login-btn" @click="wechatLogin">
	                            <i class="el-icon-wechat"></i>
	                            <span>微信授权登录</span>
	                        </div>
	                    </div>-->
	                </div>
	            </div>
	        </div>
	        
	        <!-- 微信账号绑定对话框 -->
	        <el-dialog
	            title="绑定微信账号"
	            :visible.sync="showBindDialog"
	            width="400px"
	            @close="closeBindDialog">
	            <el-form :model="bindForm" :rules="bindRules" ref="bindForm" label-width="80px">
	                <el-form-item label="账号" prop="username">
	                    <el-input 
	                        type="text" 
	                        v-model="bindForm.username" 
	                        autocomplete="off"
	                        placeholder="请输入您的系统账号">
	                    </el-input>
	                </el-form-item>
	                <el-form-item label="密码" prop="password">
	                    <el-input 
	                        type="password" 
	                        v-model="bindForm.password" 
	                        autocomplete="off"
	                        show-password
	                        placeholder="请输入您的系统密码">
	                    </el-input>
	                </el-form-item>
	            </el-form>
	            <span slot="footer" class="dialog-footer">
	                <el-button @click="closeBindDialog">取消</el-button>
	                <el-button type="primary" @click="bindWechatAccount">绑定并登录</el-button>
	            </span>
	        </el-dialog>
	        
	        <div class="footer">
	            ©版权所有 {{systemInfo.copyright}} 
	            <span class="padding-5">版本：{{systemInfo.version}}</span>
	            <span class="padding-5">|</span>
	            <a href="#">用户协议</a>
	            <a href="#">隐私政策</a>
	        </div>
	    </div>
</template>

<script>
	import jwt from 'jwt-decode'
	import store from '../../store'
	import base from '../../api/base.js'
	import { validUsername, validPassword } from '@/utils/validate'
	import {
		mapMutations
	} from 'vuex'
	
	export default {
		data() {
			var validateUser = (rule, value, callback) => {
				if (!validUsername(value)) {
				  callback(new Error('用户名称必须是字母、数字、下划线组合，且长度5-12位'))
				} else {
				  callback()
				}
			};
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					callback();
				}
			};
			var validateCapt = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入验证码'));
				} else {
					callback();
				}
			};
			return {
				systemInfo:{
				title: '',
				copyright:'',
				beian:'',
				version:'',
				},
				loginForm: {
					username:'',
					password: '',
					captcha: '',
					uniqid:'',
				},
				rules: {
					username: [{
						validator: validateUser,
						trigger: 'blur'
					}],
					password: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					captcha:[
						{
							validator: validateCapt,
							trigger: 'blur'
						}
					]
				},
				codeUrl: '',
				loading: false,
				redirect: undefined,
				otherQuery: {},
				// 微信绑定相关
				showBindDialog: false,
				bindForm: {
					username: '',
					password: '',
					wechat_code: '',
					wechat_state: ''
				},
				bindRules: {
					username: [{
						validator: validateUser,
						trigger: 'blur'
					}],
					password: [{
						validator: validatePass,
						trigger: 'blur'
					}]
				}
			};
		},
		watch: {
		  $route: {
		    handler: function(route) {
		      const query = route.query
		      if (query) {
		        this.redirect = query.redirect
		        this.otherQuery = this.getOtherQuery(query)
		      }
		    },
		    immediate: true
		  }
		},		
		methods: {			
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						//请求登录接口------------- 
						this.$http.post('login/login',this.loginForm).then(res => {							
							if (res.code ==11108) {
								console.log('-----', res.data);
								//console.log(jwt(res.data.data.token));
								let obj = {
									user: res.data.username,
									token:res.data.token,
									user_id:res.data.id,
									photo:res.data.head_img,
									auth:res.data.auth,
									authMenu:res.data.authMenu,
								}
								store.state.loginModule.userInfo=obj;			
								//存储本地
								localStorage.setItem('user', JSON.stringify(obj))
								//跳转
								this.$router.push('/')
							} else {
								//账号或者密码错误
								this.getCode();
								this.$message.error(res.msg);
							}
						})

					} else {
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			getCode() { 
				this.$http.get('login/captcha',{}).then(res => {
					if (res.code ==200) {
						console.log('-----', res.data);
						this.codeUrl=res.data.image;
						this.loginForm.uniqid=res.data.uniqid;
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			getInfo() {
				this.$http.get('index/getsystemInfo',{}).then(res => {
					if (res.code ==200) {
						console.log('-----', res.data);
						this.systemInfo=res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			getOtherQuery(query) {
			  return Object.keys(query).reduce((acc, cur) => {
			    if (cur !== 'redirect') {
			      acc[cur] = query[cur]
			    }
			    return acc
			  }, {})
			},
			// 微信授权登录
			wechatLogin() {
				// 获取微信授权配置（包含授权URL和state）
				this.$http.get('admin/login/wechatConfig').then(res => {
					if (res.code === 200) {
						const { url, state } = res.data;
						
						// 打开微信授权页面（新窗口）
						const wechatWindow = window.open(url, 'wechat_login', 'width=450,height=600');
						
						// 监听窗口关闭事件，检查是否完成授权
						const checkWechatLogin = setInterval(() => {
							if (wechatWindow.closed) {
								clearInterval(checkWechatLogin);
								// 检查本地存储是否有微信登录结果
								const wechatResult = localStorage.getItem('wechat_login_result');
								if (wechatResult) {
									localStorage.removeItem('wechat_login_result');
									const result = JSON.parse(wechatResult);
									this.handleWechatLoginResult(result);
								}
							}
						}, 1000);
					} else {
						this.$message.error('微信登录配置获取失败');
					}
				}).catch(error => {
					this.$message.error('微信登录服务暂时不可用');
					console.error('微信登录配置获取失败:', error);
				});
			},
			
			// 处理微信登录结果
			handleWechatLoginResult(result) {
				const { code, msg, data } = result;
				
				if (code === 11108) {
					// 登录成功
					let obj = {
						user: data.username,
						token: data.token,
						user_id: data.id,
						photo: data.head_img,
						auth: data.auth,
						authMenu: data.authMenu,
					};
					store.state.loginModule.userInfo = obj;
					localStorage.setItem('user', JSON.stringify(obj));
					this.$router.push('/');
					this.$message.success('微信登录成功！');
				} else if (code === 11105) {
					// 需要绑定账号
					this.showBindDialog = true;
					this.bindForm = {
						username: '',
						password: '',
						code: result.wechat_code,
						state: result.wechat_state
					};
				} else {
					this.$message.error(msg || '微信登录失败');
				}
			},
			
			// 绑定微信账号
			bindWechatAccount() {
				this.$refs.bindForm.validate((valid) => {
					if (valid) {
						this.$http.post('admin/login/wechatConfig', this.bindForm).then(res => {
							if (res.code === 11108) {
								// 绑定并登录成功
								let obj = {
									user: res.data.username,
									token: res.data.token,
									user_id: res.data.id,
									photo: res.data.head_img,
									auth: res.data.auth,
									authMenu: res.data.authMenu,
								};
								store.state.loginModule.userInfo = obj;
								localStorage.setItem('user', JSON.stringify(obj));
								this.showBindDialog = false;
								this.$router.push('/');
								this.$message.success('账号绑定成功并已登录！');
							} else {
								this.$message.error(res.msg);
							}
						}).catch(error => {
							this.$message.error('绑定请求失败');
							console.error('绑定请求失败:', error);
						});
					}
				});
			},
			
			// 关闭绑定对话框
			closeBindDialog() {
				this.showBindDialog = false;
				this.bindForm = {
					username: '',
					password: '',
					code: '',
					state: ''
				};
			}
		},
		created(){
			this.getCode();
			this.getInfo();
			//console.log(process.env.VUE_APP_NAME,process.env.VUE_APP_MACHINEID)
		}
	}
</script>

 <style scoped>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }        
        #main {
            font-family: 'Microsoft YaHei', 'Segoe UI', Arial, sans-serif;
            background: linear-gradient(135deg, #1a3a8f 0%, #0c1d50 100%);
            min-height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            position: relative;
        }
        
        /* 背景装饰元素 */
        .bg-shapes {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 0;
            overflow: hidden;
        }
        
        .shape {
            position: absolute;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.05);
        }
        
        .shape:nth-child(1) {
            width: 300px;
            height: 300px;
            top: -150px;
            left: -150px;
        }
        
        .shape:nth-child(2) {
            width: 200px;
            height: 200px;
            bottom: -100px;
            right: -100px;
        }
        
        .shape:nth-child(3) {
            width: 150px;
            height: 150px;
            top: 30%;
            right: 10%;
        }
        
        .wrapper {
            width: 100%;
            max-width: 1200px;
            padding: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            z-index: 10;
        }
        
        .login-content {
            display: flex;
            align-items: center;
            width: 100%;
        }
        
        .login-intro {
            flex: 1;
            padding: 40px;
            color: white;
            max-width: 600px;
        }
        
        .login-intro h1 {
            font-size: 42px;
            font-weight: 700;
            margin-bottom: 20px;
            line-height: 1.3;
            text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
            text-align: center;
        }
        
        .login-intro p {
            font-size: 18px;
            line-height: 1.8;
            margin-bottom: 30px;
            opacity: 0.9;
            max-width: 90%;
        }
        
        .features {
            display: flex;
            flex-wrap: wrap;
            gap: 15px;
            margin-top: 30px;
        }
        
        .feature {
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(5px);
            border-radius: 10px;
            padding: 15px;
            width: calc(50% - 10px);
            display: flex;
            align-items: center;
        }
        
        .feature-icon {
            width: 40px;
            height: 40px;
            background: #4a6fff;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 15px;
            flex-shrink: 0;
        }
        
        .feature-icon i {
            font-size: 20px;
            color: white;
        }
        
        .login-box {
            background: rgba(255, 255, 255, 0.95);
            border-radius: 16px;
            padding: 40px 35px;
            width: 100%;
            max-width: 480px;
            box-shadow: 0 15px 35px rgba(0, 20, 80, 0.3);
            position: relative;
            overflow: hidden;
            z-index: 2;
        }
        
        .login-box::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 6px;
            background: linear-gradient(90deg, #1e6bff, #2aa7ff);
            border-radius: 8px 8px 0 0;
        }
        
        .title {
            text-align: center;
            color: #1a3a8f;
            font-size: 28px;
            font-weight: 700;
            margin-bottom: 35px;
            position: relative;
            padding-bottom: 15px;
        }
        
        .title::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 80px;
            height: 4px;
            background: linear-gradient(90deg, #1e6bff, #2aa7ff);
            border-radius: 2px;
        }
        
        .el-form {
            margin-top: 10px;
        }
        
        .el-form-item {
            margin-bottom: 28px;
        }
        
        .el-form-item__label {
            color: #1a3a8f;
            font-weight: 600;
        }
        
        .el-input__inner {
            height: 46px;
            border-radius: 8px;
            border: 1px solid #dcdfe6;
            padding: 0 15px;
            transition: all 0.3s;
        }
        
        .el-input__inner:focus {
            border-color: #1e6bff;
            box-shadow: 0 0 0 2px rgba(30, 107, 255, 0.2);
        }
        
        .captcha-container {
            display: flex;
            align-items: center;
            gap: 15px;
        }
        
        .login-code-img {
            height: 46px;
            border-radius: 8px;
            border: 1px solid #dcdfe6;
            cursor: pointer;
            transition: all 0.3s;
        }
        
        .login-code-img:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }
        
        .button-container {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
        }
        
        .el-button {
            height: 46px;
            border-radius: 8px;
            font-weight: 600;
            font-size: 16px;
            transition: all 0.3s;
        }
        
        .el-button--primary {
            background: linear-gradient(90deg, #1e6bff, #2aa7ff);
            border: none;
            flex: 1;
            margin-right: 15px;
        }
        
        .el-button--primary:hover {
            background: linear-gradient(90deg, #1a5ae0, #228ce0);
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(30, 107, 255, 0.3);
        }
        
        .el-button:not(.el-button--primary) {
            flex: 1;
            border: 1px solid #1e6bff;
            color: #1e6bff;
        }
        
        .el-button:not(.el-button--primary):hover {
            background: rgba(30, 107, 255, 0.05);
            transform: translateY(-2px);
        }
        
        /* 微信登录样式 */
        .wechat-login-section {
            margin-top: 30px;
            text-align: center;
        }
        
        .divider {
            position: relative;
            margin-bottom: 20px;
        }
        
        .divider::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            right: 0;
            height: 1px;
            background: #dcdfe6;
            z-index: 1;
        }
        
        .divider span {
            position: relative;
            background: white;
            padding: 0 15px;
            color: #909399;
            font-size: 14px;
            z-index: 2;
        }
        
        .wechat-login-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 200px;
            height: 46px;
            background: #07c160;
            color: white;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.3s;
            font-size: 16px;
            font-weight: 600;
        }
        
        .wechat-login-btn:hover {
            background: #06ad56;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(7, 193, 96, 0.3);
        }
        
        .wechat-login-btn i {
            margin-right: 8px;
            font-size: 20px;
        }
        
        .footer {
            position: absolute;
            bottom: 20px;
            left: 0;
            width: 100%;
            text-align: center;
            color: rgba(255, 255, 255, 0.7);
            font-size: 14px;
            z-index: 5;
        }
        
        .footer a {
            color: rgba(255, 255, 255, 0.9);
            text-decoration: none;
            margin: 0 5px;
        }
        
        .footer a:hover {
            text-decoration: underline;
        }
        
        .padding-5 {
            padding: 0 5px;
        }
        
        .system-logo {
            display: flex;
            justify-content: center;
            margin-bottom: 25px;
        }
        
        .logo-icon {
            width: 60px;
            height: 60px;
            background: linear-gradient(135deg, #1e6bff, #2aa7ff);
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 5px 15px rgba(30, 107, 255, 0.3);
        }
        
        .logo-icon i {
            font-size: 32px;
            color: white;
        }
        
        /* 响应式设计 */
        @media (max-width: 992px) {
            .login-content {
                flex-direction: column;
            }
            
            .login-intro {
                text-align: center;
                padding: 30px 20px;
                max-width: 100%;
            }
            
            .login-intro p {
                max-width: 100%;
            }
            
            .features {
                justify-content: center;
            }
            
            .feature {
                width: 100%;
                max-width: 350px;
            }
            
            .login-box {
                max-width: 100%;
            }
        }
        
        @media (max-width: 576px) {
            .wrapper {
                padding: 15px;
            }
            
            .login-intro h1 {
                font-size: 32px;
            }
            
            .login-box {
                padding: 30px 20px;
            }
            
            .title {
                font-size: 24px;
            }
            
            .button-container {
                flex-direction: column;
                gap: 12px;
            }
            
            .el-button {
                width: 100%;
                margin: 0;
            }
            
            .wechat-login-btn {
                width: 100%;
            }
        }
    </style>